













import { defineComponent } from "@vue/composition-api";
import { useGroups } from "@/hooks/useGroups";
import AddNewGroup from "@/components/AddNewGroup";
import BasePage from "@/components/BasePage";
import GroupList from "@/components/GroupList";
import GroupMenu from "@/components/GroupMenu";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageGroups",
  components: { BasePage, PageTitle, GroupList, GroupMenu, AddNewGroup },
  setup() {
    const { loading, groups, getData } = useGroups({ system: true, blockedUsers: true });

    getData();

    return {
      loading,
      groups,
      getData,
    };
  },
});
